import { ColumnDef } from "@tanstack/react-table";
import { CellContext } from "@tanstack/table-core/build/lib/core/cell";
import { StringOrTemplateHeader } from "@tanstack/table-core/build/lib/types";

import { TableMetaProps } from "@/hooks/table/useTableConfig";

export type ColumnProps<T> = {
  accessorFn: (row: T) => string | number | null | undefined;
  id: string;
  header: StringOrTemplateHeader<T, unknown>;
  cell: (info: CellContext<T, unknown>) => React.ReactNode;
  meta?: TableMetaProps;
} & Partial<Omit<ColumnDef<T, unknown>, "accessorFn" | "id" | "header" | "cell" | "footer" | "meta">>;

const BaseColumn = <T>({ accessorFn, id, header, cell, meta, ...props }: ColumnProps<T>): ColumnDef<T> => {
  return {
    accessorFn: accessorFn,
    id: id,
    header: header,
    cell: cell,
    footer: (props) => props.column.id,
    meta: meta,
    ...props,
  };
};

export default BaseColumn;
